import { inject, Injectable } from '@angular/core';
import { MultiselectItem } from '@ui/aos-lib';
import { map, Observable, take, tap } from 'rxjs';
import { ReportGroupFilterApiService } from './report-group-filter-api.service';
import { ReportGroupFilterResponse } from './report-group-filter-api.types';
import { FilterModel } from '../../../shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { REPORT_GROUP } from '../../../shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { GroupStatus } from 'src/app/pages/administration/report-groups/report-groups.types';

@Injectable({ providedIn: 'root' })
export class ReportGroupFilterListingService {
  reportGroupFilterApiService = inject(ReportGroupFilterApiService);

  #reportGroupFilter: FilterModel = REPORT_GROUP;

  set filter(filter: FilterModel) {
    this.#reportGroupFilter = filter;
  }

  get filter(): FilterModel {
    return this.#reportGroupFilter;
  }

  updateFilter(applicable: string): Observable<ReportGroupFilterResponse[]> {
    return this.reportGroupFilterApiService.getReportGroup(applicable).pipe(
      take(1),
      tap((groups: ReportGroupFilterResponse[]) => {
        const reportGroupMultiselectItems: MultiselectItem[] = groups.map(({ groupName, groupUID, groupStatus }) => ({
          text: groupName,
          value: groupUID,
          isDisabled: groupStatus === GroupStatus.Calculating
        }));
        this.#reportGroupFilter = {
          ...this.#reportGroupFilter,
          items: reportGroupMultiselectItems,
          selected: reportGroupMultiselectItems
        };
      })
    );
  }

  getFilter(applicable: string): Observable<FilterModel> {
    return this.reportGroupFilterApiService.getReportGroup(applicable).pipe(
      map((groups: ReportGroupFilterResponse[]) => {
        const reportGroupMultiselectItems: MultiselectItem[] = groups.map(({ groupName, groupUID, groupStatus }) => ({
          text: groupName,
          value: groupUID,
          isDisabled: groupStatus === GroupStatus.Calculating
        }));

        return {
          ...REPORT_GROUP,
          items: reportGroupMultiselectItems,
          selected: reportGroupMultiselectItems
        };
      })
    );
  }
}
